'use strict';
import Barba from 'barba.js';
import Env from '../base/env.js';
import Channels from '../base/channels'
import Base from '../modules/civilisation/Base'
import RevealFx from '../fx/RevealFx'
import ParallaxFx from '../fx/ParallaxFxHori'
import ItemRevealFx from '../fx/ItemRevealFx'
import PlayerVideo from '../modules/Player'
import gsap from 'gsap'
import AnchorsMobile from '../modules/civilisation/AnchorsMobile'
import Haikus from '../modules/civilisation/Haikus'
import Comments from '../modules/civilisation/Comments'
import FullscreenSticky from '../fx/FullscreenSticky'


let page

class Page
{
    constructor(view='')
    {
        this.view = view
        this.classView = 'currentView--civiSingle'
        this.$logo = this.view.querySelector('.jsLogo')
        // Launch Fn
        this.funcLaunch = this.intro.bind(this)
        if(Env.framework.UI.launcher.LAUNCHED == false) this.channels()
    }

    channels()
    {
        Channels.on('launcher::exit',this.funcLaunch)
    }

    destroy()
    {
      if(typeof this.fullscreenSticky != 'undefined') {
        this.fullscreenSticky.destroy()
      }
      Channels.removeListener('launcher::exit', this.funcLaunch);
    }

    finalize()
    {
      setTimeout(() => {
          if(Env.isVisiting === true) {
              this.intro()
          }
      }, Env.introBaseDelay);
      this.setupVideos()
      if(this.view.querySelector('.jsHaikus--view') != null) {
        this.haikus = new Haikus(this.view.querySelector('.jsHaikus--view'))
      }
      if(this.view.querySelector('.jsComments--view') != null) {
        this.comments = new Comments(this.view.querySelector('.jsComments--view'))
      }
      if(Env.mobileCSS == true || Env.isIpad == true) {
        this.baseNavigationMobile = new RevealFx(this.view)
        this.setupAnchorsMobile()
      } else {
        this.baseNavigation = new Base(this.view)
        this.baseNavigation.setup()
        this.fx()
      }
      this.goToAnchor()
    }



    fx()
    {
      const $parallaxes = this.view.querySelectorAll('.jsParallax--view')
      for(let $para of $parallaxes) {
        const instance = new ParallaxFx($para)
        instance.animate()
      }

      const $itemsReveal = this.view.querySelectorAll('.jsRevealItem--view')
      for(let $item of $itemsReveal) {
        const instance = new ItemRevealFx($item)
        instance.animate()
      }

      this.fullscreenSticky = new FullscreenSticky(this.view)
      this.fullscreenSticky.animate()
    }

    goToAnchor()
    {
      let getParams = (new URL(document.location)).searchParams;
      const getAnchor = getParams.get('anchor')

      if(getAnchor != null && getAnchor == 'articles') {
        const getViews = this.view.querySelectorAll('.jsAnchor--view')
        for (let $view of getViews) {
          const $attachAnchor = $view.getAttribute('data-anchor')
          if($attachAnchor == getAnchor) {
            if(Env.mobileCSS == true ) {
              setTimeout(() => {
                const scroll = Env.framework.toolbox.scrollPosition()
                const coord = $view.getBoundingClientRect()
                window.scroll(0,coord.y + scroll.scrollY )
              }, 1000);

            } else {
              const coord = $view.getBoundingClientRect()
              const getScrollHeight = Env.framework.toolbox.scrollPosition().fullPageHeight
              const ratio = (getScrollHeight - window.innerWidth) / getScrollHeight
              const positionInScroll = coord.x / ratio
              window.scroll(0,positionInScroll)
            }
            return false;
          }
        }
      }


    }

    intro()
    {
      const $intro = this.view.querySelector('.jsIntro')
      const $elementsA = [$intro.querySelectorAll('.jsFxA')]
      const $elementsB = [$intro.querySelectorAll('.jsFxB'),this.view.querySelector('.jsChapter')]
      const tl = gsap.timeline()

      tl.add([
        gsap.fromTo($elementsA , { autoAlpha: 0 },{ autoAlpha: 1, ease:'cubic.out' , duration:1 , stagger:.2 }),
        gsap.fromTo($elementsB , { autoAlpha: 0, y: 20 },{ autoAlpha: 1 , y:0, ease:'cubic.out' , duration:1 , stagger:.2 }),
      ])
    }

    setupAnchorsMobile()
    {
      const $anchors = this.view.querySelectorAll('.jsAnchors--view')
      for(let $anchor of $anchors) {
        const instance = new AnchorsMobile($anchor)
      }
    }

    setupVideos()
    {
      const $players = this.view.querySelectorAll('.jsPlayer')
      for(let $player of $players) {
        const instance = new PlayerVideo($player)
        instance.setup()
      }
    }
}

page = Barba.BaseView.extend({
    namespace: 'civiSingle',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onEnterCompleted:function()
    {
        this.node.finalize()
    },
    onLeave: function()
    {
        this.node.destroy()
    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;
